import axios from 'axios';
import AuthService from './auth.service';
import { API_URL } from './api.service';

// Control global de la sesión del admin. El token dura 24h; antes, cuando
// vencía, las llamadas fallaban en silencio (muchas con .catch vacío) y la
// pantalla se quedaba cargando. Ahora se cierra la sesión y se va al login.

const LOGIN_PATH = `${process.env.PUBLIC_URL || ''}/login`;
let redirecting = false;

// Vencimiento del JWT en milisegundos (campo exp del payload), o null
export const getTokenExpiration = (token) => {
  try {
    const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const data = JSON.parse(window.atob(payload));
    return data.exp ? data.exp * 1000 : null;
  } catch (e) {
    return null;
  }
};

export const isSessionValid = () => {
  const user = AuthService.getCurrentUser();
  if (!user || !user.token) return false;
  const exp = getTokenExpiration(user.token);
  return !exp || exp > Date.now();
};

export const redirectToLogin = (expired) => {
  if (redirecting) return;
  redirecting = true;
  AuthService.logout();
  window.location.replace(expired ? `${LOGIN_PATH}?expired=1` : LOGIN_PATH);
};

export const expireSession = () => redirectToLogin(true);

// 401 del backend actual, o 422 "Token requerido" del backend anterior
const isAuthFailure = (status, data) =>
  status === 401 ||
  (status === 422 && data && data.message === 'Token requerido');

const isApiCall = (config) =>
  !!(config && config.url && config.url.indexOf(API_URL) === 0) &&
  config.url.indexOf(API_URL + 'login') !== 0;

let installed = false;

export const setupSessionControl = () => {
  if (installed) return;
  installed = true;

  // Antes de llamar al API: si el token ya venció, no se hace la llamada
  axios.interceptors.request.use((config) => {
    if (isApiCall(config) && AuthService.getCurrentUser() && !isSessionValid()) {
      expireSession();
      return Promise.reject(new axios.Cancel('Sesión expirada'));
    }
    return config;
  });

  axios.interceptors.response.use(
    (response) => {
      // Algunas llamadas aceptan 422 como respuesta válida (validateStatus)
      if (
        isApiCall(response.config) &&
        AuthService.getCurrentUser() &&
        isAuthFailure(response.status, response.data)
      ) {
        expireSession();
      }
      return response;
    },
    (error) => {
      const res = error && error.response;
      if (
        res &&
        isApiCall(res.config) &&
        AuthService.getCurrentUser() &&
        isAuthFailure(res.status, res.data)
      ) {
        expireSession();
      }
      return Promise.reject(error);
    }
  );

  // Al volver a la pestaña después de un rato
  document.addEventListener('visibilitychange', () => {
    if (
      document.visibilityState === 'visible' &&
      AuthService.getCurrentUser() &&
      !isSessionValid()
    ) {
      expireSession();
    }
  });
};
